export enum UserGroup {
    LawFirm = '1',
    Court = '2',
}

export enum OrgChangePermissions {
    OrgManager = "Org Manager",
    SendPassword = "Send Password",
    ModifyOrg = "Modify Org",
    RemoveMember = "Remove Member",
    AddModifyMember = "Add/Modify Member"
}

export const internalFSXUserTypes:string[] = ['SA'];

export interface UserPermissions {
    userType: UserGroup;
    isAdmin: boolean;
    isInternalUser: boolean;
    canModifyOrg: boolean;
    changePermissions: OrgChangePermissions[];
    nonSubscribing: boolean;
}
